import { useCallback } from "react";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import * as Composition from "./composition";
import * as Repository from "../../../repository";

import type * as Shared from "../../../../_shared";

type Props = {
	viewModel: Shared.Model.Type.FormModel["ViewModel"];
	onSuccessCallback: () => void;
};

export const useVoucherCreate = ({ viewModel, onSuccessCallback }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { onVoucherCreate: _onVoucherCreate } = Repository.Mutation.UseCase.useVoucherCreate();
	/**
	 * 宿泊券の作成
	 */
	const onVoucherCreate = useCallback(() => {
		showLoadingScreenCallback();

		const input = Composition.viewModelToInputConverter({ viewModel });
		_onVoucherCreate(input)
			.then(({ errors }) => {
				if (!errors) {
					notifyUserEventInfo({
						variant: "default",
						title: "宿泊券を保存しました",
					});
					onSuccessCallback();
				}
			})
			.finally(() => {
				hideLoadingScreenCallback();
			});
	}, [_onVoucherCreate, hideLoadingScreenCallback, onSuccessCallback, showLoadingScreenCallback, viewModel]);

	return {
		onVoucherCreate,
	};
};
